import React, { createContext, useEffect, useState, useContext } from "react";
import { v4 as uuidv4 } from "uuid";
import { CarrierContext } from "../contexts/CarrierContext";
import { postData } from "../services/guestService";

export const LogContext = createContext();

export const LogProvider = ({ children }) => {
  const carrierContxt = useContext(CarrierContext);
  // Base64 encode the JSON string
  function base64Encode(jsonString) {
    // Encoding the JSON string into Base64
    return btoa(encodeURIComponent(jsonString));
  }
  const Log = (
    log_event,
    log_type,
    case_num,
    message,
    message_type,
    api_request,
    api_response,
    api_url,
    status_code
  ) => {
    const guid = uuidv4();
    const urlCarrier = carrierContxt.hasOwnProperty("carrier")
      ? carrierContxt.carrier
      : null;
    const carr_code = "REACT_APP_" + urlCarrier.toUpperCase();
    const carr_code_val = process.env[carr_code];
    const client_id = "REACT_APP_LOG_API_CLIENT_ID_" + carr_code_val;
    const client_secret = "REACT_APP_LOG_API_CLIENT_SECRET_" + carr_code_val;
    const payload = new FormData();
    //console.log(message);
    // Append your form fields to FormData
    payload.append("log_event", log_event);
    payload.append("site_cd", process.env[carr_code] + "GPT");
    payload.append("carrier_code", process.env[carr_code]);
    payload.append("source_code", "GPT");
    payload.append("region", process.env.REACT_APP_REGION);
    payload.append("log_type", log_type);
    payload.append("case_num", case_num);
    payload.append("request", base64Encode(JSON.stringify(api_request)));
    payload.append("response", JSON.stringify(api_response));
    payload.append("message", message);
    payload.append("message_type", message_type);
    payload.append("api_url", api_url);
    payload.append("created_by", "GP PORTAL");
    payload.append("status_code", status_code);
    payload.append("session_id", sessionStorage.getItem("sessionId"));

    const headers = {
      "X-Hps-Trace-Id": guid,
      "X-Hps-Ts": Date.now(),
      "X-Hps-Carrier-Code": process.env[carr_code],
      "X-Hps-Sender-Id": "GUEST PAYMENT PORTAL",
      "X-Hps-SiteCd": process.env[carr_code] + "GPT",
      "X-Hps-Client-Id": process.env[client_id],
      "X-Hps-Secret-Id": process.env[client_secret],
      "X-Hps-Db-Region": process.env.REACT_APP_REGION,
    };

    postData(process.env.REACT_APP_LOG_API_URL, "", payload, headers)
      .then((result) => {
        if (result) {
          if (result.status && result.data && result.status === 200) {
            const response = result.data;
            if (!response.error) {
              if (response?.status_code === "HPS200") {
                //API success
                /*  if (response.payment_info) {
                } else {
                  console.error("Log API failed!");
                  console.error(response);
                }*/
              } else {
                console.error(
                  "Log API failed! Got response status code as: " +
                    response?.status_code
                );
                console.error(response);
              }
            } else {
              console.error(
                "Log API failed! Got response status code as: " +
                  response?.status_code
              );
              console.error(response);
            }
          } else if (result?.status === 404) {
            console.error(
              "Log API failed! Got result status as: " + result?.status
            );
            console.error(result);
          } else {
            const errorTxt =
              "Log API failed! Got result status as: " + result?.status;
            var resultErr = "";
            if (result.error) {
              resultErr = result.error;
            }
            if (result.errors && result.errors.text) {
              resultErr += result.errors.text;
            }
            console.error(errorTxt + resultErr);
          }
        } else {
          console.error("Log API failed!");
          console.log(process.env.REACT_APP_LOG_API_URL);
          console.log(payload);
          console.log(headers);
        }
      })
      .catch((error) => {
        console.error("Log API failed! Got exception!");
        let err_msg = "";
        if (error.response) {
          // The request was made and the server responded with a status code
          err_msg =
            error?.response?.status + ": " + error?.response?.statusText;
        } else if (error.request) {
          // The request was made but no response was received
          err_msg = error?.request?.status + ": " + error?.request?.statusText;
        } else {
          // Something happened in setting up the request that triggered an Error
          err_msg = error.message ? error.message : "";
        }
        console.error(err_msg);
      })
      .finally(() => {
        // Code that runs regardless of success or failure
      });
  };
  /* Toast */
  return (
    <LogContext.Provider
      value={{
        Log,
      }}
    >
      {children}
    </LogContext.Provider>
  );
};
